var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.72738 12.5356C3.18761 12.5356 3.56071 12.9086 3.56071 13.3689V16.7022C3.56071 16.9232 3.64851 17.1352 3.80479 17.2915C3.96107 17.4478 4.17303 17.5356 4.39404 17.5356H16.0607C16.2817 17.5356 16.4937 17.4478 16.65 17.2915C16.8062 17.1352 16.894 16.9232 16.894 16.7022V13.3689C16.894 12.9086 17.2671 12.5356 17.7274 12.5356C18.1876 12.5356 18.5607 12.9086 18.5607 13.3689V16.7022C18.5607 17.3653 18.2973 18.0011 17.8285 18.47C17.3596 18.9388 16.7238 19.2022 16.0607 19.2022H4.39404C3.731 19.2022 3.09512 18.9388 2.62628 18.47C2.15744 18.0011 1.89404 17.3653 1.89404 16.7022V13.3689C1.89404 12.9086 2.26714 12.5356 2.72738 12.5356Z",
    fill: "#2196F3",
    stroke: "#2196F3",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47162 8.61297C5.79705 8.28754 6.32469 8.28754 6.65013 8.61297L10.2275 12.1904L13.8049 8.61297C14.1304 8.28754 14.658 8.28754 14.9835 8.61297C15.3089 8.93841 15.3089 9.46605 14.9835 9.79149L10.8168 13.9582C10.4914 14.2836 9.96372 14.2836 9.63828 13.9582L5.47162 9.79149C5.14618 9.46605 5.14618 8.93841 5.47162 8.61297Z",
    fill: "#2196F3",
    stroke: "#2196F3",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2274 2.53555C10.6876 2.53555 11.0607 2.90865 11.0607 3.36889V13.3689C11.0607 13.8291 10.6876 14.2022 10.2274 14.2022C9.76714 14.2022 9.39404 13.8291 9.39404 13.3689V3.36889C9.39404 2.90865 9.76714 2.53555 10.2274 2.53555Z",
    fill: "#2196F3",
    stroke: "#2196F3",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.37f72670fffbef6a0b1c88dc4ba54d02.svg";
export { ForwardRef as ReactComponent };